module.exports = __webpack_public_path__ + "img/truck-flatbed.80cca3ba.svg";